import React, { useCallback, useState } from "react";

import MyModal from "../Common/MyModal";
import MyPagination from "../Common/MyPagination";
import { proxyAPI } from "../proxyAPI";

const formatDateTime = (dateTime) => {
  if (!dateTime) return "-";

  const date = new Date(
    dateTime.slice(-1) === "Z" ? dateTime : `${dateTime}Z`
  );

  return Number.isNaN(date.getTime()) ? "-" : date.toLocaleString();
};

export default function TicketStatusHistoryModal({ ticketUuid }) {
  const [statusChanges, setStatusChanges] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const getStatusChanges = useCallback(async (page = 0, perPage = 10) => {
    setLoading(true);
    setError("");

    const data = await proxyAPI({
      prefix: "logic/reporting",
      url: "ticket-status-changes",
      method: "POST",
      body: {
        filters: { tickets: [ticketUuid] },
        pagination: { page, perPage },
      },
      hideToasts: true,
    });

    if (!data) {
      setStatusChanges([]);
      setTotal(0);
      setError("Unable to load status history. Please try again.");
    } else {
      setStatusChanges(data.data ?? []);
      setTotal(data.total ?? 0);
    }

    setLoading(false);
  }, [ticketUuid]);

  const resetHistory = () => {
    setStatusChanges([]);
    setTotal(0);
    setError("");
  };

  return (
    <MyModal
      label="History"
      buttonClassName="btn-outline-secondary px-2"
      heading={`Status history: ${ticketUuid}`}
      onShow={resetHistory}
      size="lg"
    >
      <div style={{ minHeight: "160px" }}>
        {loading ? (
          <div className="text-center py-4">Loading status history…</div>
        ) : error ? (
          <div className="text-center text-danger py-4">{error}</div>
        ) : statusChanges.length ? (
              <div className="table-responsive">
                <table className="table">
                  <thead>
                    <tr>
                      <th>Status</th>
                      <th>Changed at</th>
                      <th>Changed by</th>
                    </tr>
                  </thead>
                  <tbody>
                    {statusChanges.map((change, index) => (
                      <tr
                        key={`${change.uuid}-${change.changedAt}-${change.status}-${index}`}
                      >
                        <td>{change.status}</td>
                        <td>{formatDateTime(change.changedAt)}</td>
                        <td>{change.who || "system"}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
          <div className="text-center text-secondary py-4">
            No status changes recorded.
          </div>
        )}
        <MyPagination
          total={total}
          onPaginate={getStatusChanges}
          perPageOptions={[10, 25, 50]}
          defaultPerPage={10}
        />
      </div>
    </MyModal>
  );
}